/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./ServiceTrust.css";
import { FiPhoneCall } from "react-icons/fi";
import { Link } from "react-router-dom";

export default function ServiceTrust() {
  return (
    <>
      {/* ===================== SERVICES PLACEHOLDER ===================== */}
      <section className="densat-trust-v2-services">
        {/* future content */}
      </section>

      {/* ===================== CTA SECTION ===================== */}
      <section className="densat-trust-v2-cta">
        <h2 className="densat-trust-v2-title">
          Ready to Transform Your Facility?
        </h2>

        <p className="densat-trust-v2-desc">
          Get a free site assessment and discover how we can help maintain
          world-class environments.
        </p>

        <div className="hero-buttons">
          {/* UPDATED BUTTON */}
          <Link to="/contact" className="btn-primary">
            Request a Free Site Assessment →
          </Link>

          <a href="tel:+91-9899811123" className="btn-outline">
            <FiPhoneCall className="btn-icon" />
            Call Now for a Tailored Quote
          </a>
        </div>
      </section>
    </>
  );
}
